import type { SVGProps } from 'react';

const SvgPinFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M9.90918 5.04199C9.90924 2.33571 13.181 0.980205 15.0947 2.89355L21.1064 8.90527C23.0198 10.8191 21.6643 14.0908 18.958 14.0908C18.6828 14.0908 18.4192 14.2009 18.2246 14.3955L16.5361 16.083C16.3415 16.2776 16.2315 16.5421 16.2314 16.8174C16.2312 19.5237 12.9596 20.8785 11.0459 18.9648L8.74707 16.666L3.70703 21.707C3.31651 22.0976 2.68349 22.0976 2.29297 21.707C1.90246 21.3165 1.90245 20.6835 2.29297 20.293L7.33301 15.252L5.03516 12.9541C3.12146 11.0404 4.47631 7.76775 7.18262 7.76758C7.45786 7.76756 7.72237 7.65849 7.91699 7.46387L9.60449 5.77539C9.79908 5.58077 9.90917 5.31721 9.90918 5.04199Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgPinFilled;
